(function () {
  'use strict';

  function inspectCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return 'unavailable';
    if (cart.items.some(function (item) {
      return !item || !Number.isSafeInteger(item.quantity) || item.quantity <= 0 ||
        typeof item.key !== 'string' || !item.key;
    })) return 'unavailable';
    var recurring = cart.items.some(function (item) {
      var flag = item.properties && item.properties._tac_subscription;
      return Boolean(item.selling_plan_allocation || item.selling_plan) ||
        flag === true || String(flag).trim().toLowerCase() === 'true';
    });
    return recurring ? 'subscription' : 'one_time';
  }

  function fingerprint(cart) {
    return JSON.stringify({
      token: cart.token,
      currency: cart.currency,
      total: cart.total_price,
      items: cart.items.map(function (item) {
        return [item.key, item.quantity, item.final_line_price];
      }).sort(function (a, b) { return String(a[0]).localeCompare(String(b[0])); })
    });
  }

  function routesFor(root) {
    if (typeof root !== 'string' || !/^\/(?:[a-zA-Z0-9_-]+\/)*$/.test(root)) root = '/';
    return { cart: root + 'cart.js', checkout: root + 'checkout' };
  }

  function createGate(options) {
    var readyCart;
    var busy = false;
    async function prepare() {
      if (busy) return 'busy';
      busy = true;
      readyCart = undefined;
      try {
        var cart = await options.readCart();
        var kind = inspectCart(cart);
        if (kind === 'one_time') readyCart = fingerprint(cart);
        return kind;
      } catch (_) {
        return 'unavailable';
      } finally {
        busy = false;
      }
    }
    async function proceed(confirmed) {
      if (busy) return 'busy';
      if (confirmed !== true || !readyCart) return 'confirmation_required';
      busy = true;
      var previous = readyCart;
      readyCart = undefined;
      try {
        var cart = await options.readCart();
        var kind = inspectCart(cart);
        if (kind !== 'one_time') return kind;
        if (fingerprint(cart) !== previous) return 'changed';
        options.navigate(options.checkout);
        return 'navigating';
      } catch (_) {
        return 'unavailable';
      } finally {
        busy = false;
      }
    }
    return { prepare: prepare, proceed: proceed };
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { inspectCart: inspectCart, routesFor: routesFor, createGate: createGate };
    return;
  }
  if (window.TACPaymentRecovery) return;
  var configNode = document.getElementById('tac-payment-recovery-config');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var paths = routesFor(window.Shopify && window.Shopify.routes && window.Shopify.routes.root);
  var sequence = 0;
  var mounted = new WeakMap();
  var views = new WeakMap();

  async function readCart() {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 8000);
    try {
      var response = await fetch(paths.cart, {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart unavailable');
      return await response.json();
    } finally {
      window.clearTimeout(timer);
    }
  }

  function element(tag, copy, className) {
    var node = document.createElement(tag);
    if (copy) node.textContent = copy;
    if (className) node.className = className;
    return node;
  }

  function mount(button) {
    var host = button.closest('.cart__ctas') || button;
    var existing = mounted.get(host);
    if (existing && existing.isConnected) return existing;
    var details = element('details', '', 'tac-payment-recovery');
    var summary = element('summary', config.title);
    var content = element('div', '', 'tac-payment-recovery__content');
    var note = element('p', config.warning);
    var status = element('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    var alternative = element('div');
    alternative.hidden = true;
    var label = element('label', '', 'tac-payment-recovery__confirm');
    var checkbox = element('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'tac-checkout-confirm-' + (++sequence);
    label.htmlFor = checkbox.id;
    label.append(checkbox, element('span', config.confirm));
    var standard = element('button', config.standard, 'tac-payment-recovery__button');
    standard.type = 'button';
    standard.disabled = true;
    alternative.append(label, standard);
    var help = element('a', config.help, 'tac-payment-recovery__help');
    help.href = config.whatsapp;
    help.target = '_blank';
    help.rel = 'noopener noreferrer';
    var hours = element('small', config.hours);
    content.append(note, status, alternative, help, hours);
    details.append(summary, content);
    var gate = createGate({ readCart: readCart, checkout: paths.checkout, navigate: function (url) {
      window.location.assign(url);
    } });
    function showResult(result) {
      checkbox.checked = false;
      standard.disabled = true;
      alternative.hidden = result !== 'one_time';
      status.textContent = result === 'one_time' ? config.ready :
        result === 'subscription' ? config.subscription :
        result === 'changed' ? config.changed : config.unavailable;
    }
    async function refresh() {
      alternative.hidden = true;
      checkbox.checked = false;
      standard.disabled = true;
      status.textContent = config.checking;
      showResult(await gate.prepare());
    }
    details.addEventListener('toggle', function () {
      if (details.open) refresh();
    });
    window.addEventListener('pageshow', function () {
      checkbox.checked = false;
      standard.disabled = true;
      if (details.open && details.isConnected) refresh();
    });
    checkbox.addEventListener('change', function () { standard.disabled = !checkbox.checked; });
    standard.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      standard.disabled = true;
      status.textContent = config.checking;
      var result = await gate.proceed(checkbox.checked);
      if (result === 'navigating' || result === 'busy') return;
      showResult(result);
      if (result === 'changed') {
        await refresh();
        status.textContent = config.changed;
      }
    });
    host.insertAdjacentElement('afterend', details);
    mounted.set(host, details);
    views.set(details, { refresh: refresh });
    return details;
  }

  function scan() {
    document.querySelectorAll('[data-tac-subscription-checkout],button[name="checkout"],input[name="checkout"],.cart__checkout-button').forEach(mount);
  }
  function show(button) {
    if (!button || !button.isConnected) return;
    var details = mount(button);
    if (details.open) views.get(details).refresh();
    else details.open = true;
    details.querySelector('summary').focus();
  }
  window.TACPaymentRecovery = { show: show };
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
